module.exports = __webpack_public_path__ + "media/images/stat-cards-today-dark-81ef388f.svg";